var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgressbarLetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_96"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_92"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_91"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_90"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_89"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_88"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_87"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_86"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_85"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_83"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_81"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_80"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_78"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_76"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_74"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_73"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_71"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_70"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_69"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_68"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_67"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_66"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_65"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150,19.665C78.133,19.665,19.665,78.133,19.665,150S78.133,280.334,150,280.334 S280.335,221.867,280.335,150S221.867,19.665,150,19.665z M229.388,223.85c0,2.057-1.668,3.724-3.725,3.724H74.333 c-2.057,0-3.725-1.667-3.725-3.724v-90.794c0-0.111,0.013-0.219,0.022-0.328c0.002-0.02,0.002-0.038,0.004-0.058 c0.023-0.231,0.067-0.458,0.133-0.678c0.002-0.005,0.004-0.011,0.006-0.017c0.063-0.207,0.146-0.405,0.244-0.598 c0.016-0.031,0.029-0.063,0.047-0.094c0.109-0.201,0.232-0.392,0.376-0.57c0.004-0.005,0.009-0.009,0.013-0.013 c0.143-0.175,0.305-0.333,0.479-0.481c0.016-0.014,0.027-0.03,0.044-0.044l19.897-16.317V76.15c0-2.057,1.668-3.724,3.725-3.724 h108.801c2.057,0,3.725,1.667,3.725,3.724v37.704l19.905,16.322c0.032,0.026,0.055,0.059,0.085,0.086 c0.127,0.111,0.245,0.229,0.354,0.355c0.038,0.044,0.081,0.083,0.116,0.129c0.121,0.152,0.226,0.316,0.321,0.486 c0.04,0.073,0.077,0.147,0.113,0.224c0.06,0.125,0.11,0.252,0.156,0.383c0.023,0.068,0.052,0.135,0.071,0.204 c0.053,0.185,0.088,0.373,0.111,0.566c0.01,0.079,0.012,0.158,0.016,0.238c0.004,0.069,0.015,0.138,0.015,0.208V223.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "208.123,123.485 208.123,139.916 219.349,132.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "91.873,123.491 80.652,132.693 91.873,139.913  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.009,185.473c-0.462,0-0.919-0.094-1.354-0.265c-0.227-0.089-0.45-0.193-0.66-0.328l-54.411-35.007 c-0.009-0.006-0.017-0.013-0.025-0.019l-15.5-9.973v80.244h143.881v-80.244l-69.914,44.998 C151.41,185.274,150.71,185.473,150.009,185.473z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M99.322,79.874v64.832v0.003l50.687,32.61l50.665-32.61V79.874H99.322z M110.523,96.376h78.956 c1.543,0,2.793,1.251,2.793,2.794c0,1.542-1.25,2.792-2.793,2.792h-78.956c-1.543,0-2.793-1.25-2.793-2.792 C107.73,97.627,108.98,96.376,110.523,96.376z M110.512,115.459h40.265c1.543,0,2.793,1.25,2.793,2.793s-1.25,2.793-2.793,2.793 h-40.265c-1.542,0-2.792-1.25-2.792-2.793S108.97,115.459,110.512,115.459z M189.479,140.124h-78.956 c-1.543,0-2.793-1.251-2.793-2.793s1.25-2.793,2.793-2.793h78.956c1.543,0,2.793,1.251,2.793,2.793 S191.022,140.124,189.479,140.124z M189.483,121.045h-21.767c-1.543,0-2.793-1.25-2.793-2.793s1.25-2.793,2.793-2.793h21.767 c1.543,0,2.793,1.25,2.793,2.793S191.026,121.045,189.483,121.045z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M150,10.334C72.988,10.334,10.335,72.988,10.335,150S72.988,289.665,150,289.665 S289.665,227.012,289.665,150S227.012,10.334,150,10.334z M150,280.334c-71.867,0-130.335-58.467-130.335-130.334 S78.133,19.665,150,19.665S280.335,78.133,280.335,150S221.867,280.334,150,280.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M229.357,132.609c-0.023-0.191-0.059-0.381-0.111-0.566c-0.02-0.069-0.048-0.136-0.071-0.204 c-0.045-0.13-0.097-0.258-0.156-0.383c-0.036-0.076-0.073-0.151-0.113-0.224c-0.095-0.168-0.198-0.333-0.321-0.486 c-0.035-0.046-0.078-0.085-0.116-0.129c-0.108-0.125-0.226-0.244-0.354-0.355c-0.03-0.027-0.053-0.06-0.085-0.086l-19.905-16.322 V76.15c0-2.057-1.668-3.724-3.725-3.724H95.598c-2.057,0-3.725,1.667-3.725,3.724v37.708l-19.897,16.317 c-0.017,0.014-0.028,0.03-0.044,0.044c-0.176,0.149-0.338,0.309-0.479,0.481c-0.004,0.004-0.009,0.008-0.013,0.013 c-0.146,0.179-0.269,0.371-0.376,0.57c-0.018,0.031-0.031,0.063-0.047,0.094c-0.098,0.193-0.182,0.393-0.244,0.598 c-0.002,0.006-0.004,0.011-0.006,0.017c-0.065,0.222-0.109,0.449-0.133,0.678c-0.002,0.019-0.002,0.038-0.004,0.058 c-0.01,0.109-0.022,0.217-0.022,0.328v90.794c0,2.057,1.668,3.724,3.725,3.724h151.33c2.057,0,3.725-1.667,3.725-3.724v-90.794 c0-0.07-0.011-0.139-0.015-0.208C229.369,132.768,229.367,132.688,229.357,132.609z M93.558,149.854 c0.009,0.006,0.017,0.013,0.025,0.019l54.411,35.007c0.21,0.135,0.434,0.239,0.66,0.328c0.436,0.17,0.893,0.265,1.354,0.265 c0.701,0,1.401-0.198,2.016-0.593l69.914-44.998v80.244H78.058v-80.244L93.558,149.854z M99.322,144.706V79.874h101.352v64.835 l-50.665,32.61l-50.687-32.61V144.706z M219.349,132.69l-11.226,7.226v-16.431L219.349,132.69z M91.873,123.491v16.422 l-11.221-7.22L91.873,123.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M110.523,101.962h78.956c1.543,0,2.793-1.25,2.793-2.792c0-1.543-1.25-2.794-2.793-2.794h-78.956 c-1.543,0-2.793,1.251-2.793,2.794C107.73,100.712,108.98,101.962,110.523,101.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M192.272,137.331c0-1.542-1.25-2.793-2.793-2.793h-78.956c-1.543,0-2.793,1.251-2.793,2.793 s1.25,2.793,2.793,2.793h78.956C191.022,140.124,192.272,138.873,192.272,137.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M189.483,115.459h-21.767c-1.543,0-2.793,1.25-2.793,2.793s1.25,2.793,2.793,2.793h21.767 c1.543,0,2.793-1.25,2.793-2.793S191.026,115.459,189.483,115.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M110.512,121.045h40.265c1.543,0,2.793-1.25,2.793-2.793s-1.25-2.793-2.793-2.793h-40.265 c-1.542,0-2.792,1.25-2.792,2.793S108.97,121.045,110.512,121.045z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_56"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_55"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_53"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_52"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_40"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_39"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_38"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressbarLetter);
export default __webpack_public_path__ + "static/media/icon_progressbar_letter.01c7a9048c82adda8238d67b6d06549c.svg";
export { ForwardRef as ReactComponent };